import { render, staticRenderFns } from "./PrizeSection.vue?vue&type=template&id=06a7b4c8&scoped=true&"
import script from "./PrizeSection.vue?vue&type=script&lang=js&"
export * from "./PrizeSection.vue?vue&type=script&lang=js&"
import style0 from "./PrizeSection.vue?vue&type=style&index=0&id=06a7b4c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7b4c8",
  null
  
)

export default component.exports